import { createSlice } from "@reduxjs/toolkit";

export const NamesSlice = createSlice({
  name: "names",
  initialState: {
    firstName: "",
    isInValidFirstName: null,
    lastName: "",
    isInValidLastName: null,
  },
  reducers: {
    changeFirstName: (state, action) => {
      state.firstName = action.payload;
    },
    changeLastName: (state, action) => {
      state.lastName = action.payload;
    },
    changeIsInValidFirstName: (state, action) => {
      state.isInValidFirstName = action.payload;
    },
    changeIsInValidLastName: (state, action) => {
      state.isInValidLastName = action.payload;
    },
  },
});

export const {
  changeFirstName,
  changeLastName,
  changeIsInValidFirstName,
  changeIsInValidLastName,
} = NamesSlice.actions;
export default NamesSlice.reducer;
